import { z } from '../zod.js';

export const LivemodeQueryParamValidationSchema = z
  .enum(['true', 'false'])
  .transform(v => v === 'true')
  .optional()
  .openapi({
    description:
      'Set to `false` to return test-mode records created while a page was in test mode. Defaults to the mode of the API key. Test API keys can only read test data.',
  });

export const LivemodeFilterValidationSchema = z.boolean().optional().meta({
  description:
    'Set to false to read test-mode records (created while a page was in test mode). Defaults to live records.',
});

export const LivemodeGetQueryValidationSchema = z.object({
  livemode: LivemodeQueryParamValidationSchema,
});
